import React, { useState } from 'react';
import { DatePickerModal } from 'AppSrc/core/components/forms/form-base-components/sub-components/date-picker-modal';
import { CalenderSvg } from 'AppSrc/core/components/common/svg-icons';
import { getDateDisplay } from 'AppSrc/core/crq/crq-table-utils';
import PropTypes from 'prop-types';
import 'AppSrc/core/style/components/form/form-base-components/v-f-date-picker.css';

const CrqListEndDateFilter = ({
  selectedEndDate,
  setSelectedEndDate,
}) => {
  const [modalOpen, setModalOpen] = useState(false);
  const displayValue = selectedEndDate ? getDateDisplay(selectedEndDate) : 'DD/MM/YYYY';
  return (
    <div className="crq-list-date-filter v-f-field-type">
      <h3>End date</h3>
      <div className="v-f-date-picker">
        <button
          type="button"
          onClick={() => setModalOpen(true)}
          className="selected-date selected-date-modal-button"
        >
          <div className="selected-date-inner-filter">
            <p className="selected-date-text">
              {displayValue}
            </p>
            <div className="calender-svg-wrapper">
              <CalenderSvg />
            </div>
          </div>
        </button>
      </div>
      {modalOpen && (
        <DatePickerModal
          savedSelectedEndDate={selectedEndDate}
          toggleModal={() => setModalOpen(!modalOpen)}
          updateValue={(value) => {
            setSelectedEndDate(value.selectedEndDate);
            setModalOpen(false);
          }}
          showKey={false}
        />
      )}
    </div>
  );
};

CrqListEndDateFilter.propTypes = {
  selectedEndDate: PropTypes.instanceOf(Date),
  setSelectedEndDate: PropTypes.func,
};

export { CrqListEndDateFilter };
